module.exports = __webpack_public_path__ + "static/media/flag-fr.34e17258.svg";